<template>
    <div>
        <div class="column-selector">
            <!-- <label v-for="(column, key) in availableColumns" :key="key">
                <input type="checkbox" :value="key" v-model="selectedColumns" />
                {{ column.name }}
            </label> -->
            <ColumnSelector v-if="isShowSelector" :columns="availableColumns" :selectedColumns="selectedColumns"
                @setValues="updateSelections" />
        </div>
        <div class="overflow-auto">
            <table class="hrm_Table w-full max-sm:w-[900px] sm:w-[990px] xl:w-full">
                <thead>
                    <tr>
                        <slot name="tableThCheckCol"></slot>
                        <th v-for="key in selectedColumns" :key="key">
                            {{ availableColumns[key].name }}
                        </th>
                        <slot name="tableThActionCol"></slot>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(row, index) in tableData" :key="index">
                        <template v-if="true">
                            <td class="" v-if="
                                checkPermission('hrm.awards.multiple.delete') ||
                                checkPermission('hrm.awards.multiple.restore')
                            ">
                                <div class="flex items-center justify-center" v-if="row.status !== 'published'">
                                    <input id="default-checkbox" type="checkbox" :value="row.id"
                                        v-model="selectedForm" @change="selectedForm = selectedForm"
                                        class="themeInputCheckbox" />
                                </div>
                            </td>
                        </template>
                        <td v-for="key in selectedColumns" :key="key">
                            <component v-if="cellComponents[key]" :is="cellComponents[key]" :employeeData="row[key]"
                                :permissionPreview="true">
                            </component>
                            <template v-else>
                                <span v-html="row[key]"></span>
                            </template>
                        </td>
                        <slot name="tableActionCol" :option="row"></slot>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import axios from "axios";

export default {
    name: "DynamicTable",
    
    components: {
    },
    props: {
        apiEndpoint: {
            type: String,
            required: true,
        },
        cellComponents: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            availableColumns: [],
            selectedColumns: [],
            tableData: [],
            isShowSelector: true
        };
    },
    mounted() {
        this.fetchTableData();
    },
    methods: {
        fetchTableData() {
            this.isShowSelector = false;
            axios
                .get(this.apiEndpoint)
                .then((response) => {
                    this.tableData = response.data.data;
                    if (this.tableData.length > 0) {
                        this.availableColumns =
                            response.data?.columns ??
                            Object.keys(this.tableData[0]);
                        const MAIN_COLUMN = true;
                        this.selectedColumns = Object.keys(
                            this.availableColumns
                        ).filter(
                            (key) => this.availableColumns[key].main === MAIN_COLUMN
                        );
                    }
                    this.isShowSelector = true;
                })
                .catch((error) => {
                    console.error("Error fetching table data:", error);
                });
        },
        getLabelName(option) {
            let transvalue = 'lang.' + option.name.name;
            const name = this.trans(transvalue);
            return name;
        },
        updateSelections(values) {
            this.selectedColumns = values;
        }
    },
};
</script>

<style scoped>
.column-selector {
    margin-bottom: 1rem;
}
</style>
